/**
 * @file 号码认证 - 申诉举报
 * @author wence
 */

import {rcAjax} from '../util';
import {
    POST_NUMBER_REPORT,
    GET_ALREADY_PHONE_LIST,
    GET_INSTANCE_INFO
} from './ActionTypes';
import qs from 'query-string';

export const postNumberReport = params => dispatch => {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/phone/report',
        {},
        JSON.stringify({
            phone: params.phone,
            type: params.type,
            reason: params.reason,
            email: params.email,
            captcha: params.captcha
        }),
        data => {
            dispatch({type: POST_NUMBER_REPORT, data: data.data});
        }
    );
};

export const getInstanceInfo = () => dispatch => {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/instance/getInstance',
        {},
        {},
        data => {
            dispatch({type: GET_INSTANCE_INFO, data: data.data});
        }
    ).then(data => data.data);
};

export const getAlreadyPhoneList = params => dispatch => {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/phone/getAppealPhoneList',
        {},
        qs.stringify(params),
        data => {
            dispatch({type: GET_ALREADY_PHONE_LIST, data: data.data});
        }
    ).then(data => data.data);
};

export const validateNumberOwner = params => {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/account/doAuth',
        {},
        qs.stringify(params),
        data => {
            return data.data;
        },
    ).then(data => data.data);
};

export const fetchPersonComplaint = params => {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/phone/personComplaint',
        {},
        params,
        data => {
            return data.data;
        },
    ).then(data => data.data);
};

export const fetchCompanyComplaint = params => {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/phone/companyComplaint',
        {},
        params,
        data => {
            return data.data;
        },
    ).then(data => data.data);
};



// WEBPACK FOOTER //
// ./src/actions/numberOptionsActions.js